import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/app/[device]/[country]/[...slugs]/error.tsx");
